import { FC, memo } from 'react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'

const LockOutline = createIcon({
  displayName: 'LockOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="2" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M17 21h-10c-1.105 0-2-.895-2-2v-7c0-1.105.895-2 2-2h10c1.105 0 2 .895 2 2v7c0 1.105-.895 2-2 2Z"></path>
        <path d="M8 10v-3 0c0-2.209 1.791-4 4-4v0c2.209 0 4 1.791 4 4v0 3"></path>
      </g>
      <path fill="none" d="M0 0h24v24h-24Z"></path>
    </>
  ),
})

const Lock: FC<CustomIconProps> = (props) => {
  return <CustomIcon as={LockOutline} {...props} />
}

export default memo(Lock)
